import { Component } from '@opten/compiler/metadata/component';
import { FormTemplatesComponent } from './form-templates';

declare const Isotope: any;

@Component({ className: 'js-grid' })
export class GridComponent {
	constructor(private element: HTMLElement) {
		const grid = new Isotope(this.element, {
			itemSelector: '.js-grid-item',
			layoutMode: 'masonry',
		});

		FormTemplatesComponent.onFieldAdded.subscribe((field) => {
			grid.arrange();
		});
		FormTemplatesComponent.onFieldRemoved.subscribe((field) => {
			grid.arrange();
		});
	}
}
